module.exports = __webpack_public_path__ + "img/gmail-20x20.5ad9c5ed.svg";